import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';

const Omschrijving = (props) => (
    <div className="manual-omschrijving" dangerouslySetInnerHTML={{__html: props.pageOmschrijvingContent}} />
)

export default HeaderFooterHOC(Omschrijving, 'manual-omschrijving');
